import { Loader } from './Loader'

interface LoadingStateProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  fullScreen?: boolean
  className?: string
}

const LoadingState = ({ 
  message = 'Loading...', 
  size = 'md', 
  fullScreen = false,
  className = ''
}: LoadingStateProps) => {
  const containerClasses = fullScreen 
    ? 'min-h-screen bg-gray-50 flex items-center justify-center'
    : `flex items-center justify-center p-8 ${className}`

  return (
    <div className={containerClasses}>
      <Loader size={size} text={message} />
    </div>
  )
}

export default LoadingState